/* eslint-disable react/jsx-indent */
import * as React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import { Zoom } from "react-awesome-reveal";
import Image from "next/image";
import Link from "next/link";

import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";

import AgapeSlider from "../../../../common/slider/AgapeSlider";
import { dateParser } from "../../../../../helpers/dateParser";

const useStyles = makeStyles((theme) => ({
  containerParent: {
    marginTop: 60,
  },
  container: {
    width: "100%",
    padding: 0,
    backgroundColor: "#fff",
    boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.10)",
    borderRadius: "10px",
    "&:hover": {
      boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
    },
  },
  card: {
    borderTop: "solid .5px #dadada",
    padding: 10,
  },
  div: {
    padding: 7,
  },
  title: {
    fontWeight: "bold",
    fontSize: "18px",
    color: "#292929",
    marginBottom: "-20px",
    marginTop: 30,
  },
  banner: {
    // borderRadius: "10px",
  },
  logo: {
    borderRadius: "100%",
    border: "solid .5px #dadada",
  },
  grade: {
    display: "inline-block",
    width: 80,
    float: "right",
  },
  t1: {
    color: "#009693",
    fontSize: "16px",
    fontWeight: "bold",
    marginTop: 10,
    padding: 10,
  },
  t2: {
    color: "#292929",
    fontSize: "16px",
    padding: 10,
    paddingTop: 0,
  },
  t3: {
    color: "#292929",
    fontSize: "16px",
    margin: 5,
  },
  t4: {
    color: "#292929",
    fontSize: "16px",
    margin: 5,
    textAlign: "right",
  },
  bannerPar: {
    padding: "10px 0px 10px 10px",
  },
  icon: {
    fontSize: "25px",
    color: "#FF5666",
    marginBottom: "-7px",
  },
}));

const Posts = ({ posts = [] }) => {
  const classes = useStyles();

  return (
    <Zoom triggerOnce delay={1000}>
      <Grid container alignItems="center">
        <Grid item xs={8} md={4}>
          <Typography variant="h2" className={classes.title}>
            گزارشات عملکرد موسسه
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <AgapeSlider
            listLength={posts.length}
            slidesToShowDesktop={1}
            slidesToShowTablet={1}
            slidesToShowMobile={1}
            arrow
            autoplay
            infinite
            // dots
          >
            {posts.map((item) => (
              <div className={classes.div} dir="rtl">
                <Link href={`/posts/${item.slug}`}>
                  <a>
                    <Grid
                      container
                      className={classes.container}
                      //   alignItems="center"
                    >
                      <Grid item xs={3} className={classes.bannerPar}>
                        {item.logo && (
                          <Image
                            src={item.logo}
                            placeholder="blur"
                            blurDataURL={item.logo}
                            alt={item.name}
                            width={380}
                            height={177}
                            className={classes.banner}
                            layout="responsive"
                          />
                        )}
                      </Grid>
                      <Grid item xs={9}>
                        <Typography variant="h4" className={classes.t1}>
                          {item.name}
                        </Typography>
                        <Typography variant="h5" className={classes.t2}>
                          {item.summary}
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={12}
                        alignItems="center"
                        className={classes.card}
                      >
                        <Grid xs={6}>
                          <Typography variant="h5" className={classes.t3}>
                            <ThumbUpOutlinedIcon className={classes.icon} />{" "}
                            {item.like_count}
                          </Typography>
                        </Grid>
                        <Grid xs={6}>
                          <Typography variant="h5" className={classes.t4}>
                            <EditCalendarOutlinedIcon
                              className={classes.icon}
                            />{" "}
                            {dateParser(item.created_at)}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </a>
                </Link>
              </div>
            ))}
          </AgapeSlider>
        </Grid>
      </Grid>
    </Zoom>
  );
};

export default Posts;
